module.exports = __webpack_public_path__ + "static/erweima-pledge.30b6418c.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/erweima-pledge.png
// module id = 980
// module chunks = 2